import { useMemo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

export const useProjectId = (isEnforced = true) => {
  const params = useParams()
  const projectId = useMemo(() => params.projectId, [params])
  const navigate = useNavigate()

  if (!projectId && isEnforced) {
    navigate('/projects')
    return ''
  }

  return projectId
}
